import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-slate-900 dark:text-white">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function TableShell({ children }) {
  return (
    <Card className="border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden p-0">
      <div className="overflow-x-auto">{children}</div>
    </Card>
  );
}

export function Loading() {
  return (
    <div className="flex items-center justify-center py-24">
      <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
    </div>
  );
}

export function EmptyState({ message }) {
  return <div className="py-16 text-center text-sm text-slate-500">{message}</div>;
}
